export enum NoteType {
  General = 0,
  WorkOrderRequested = 1,
  WorkOrderCompleted = 2
}
